import { isAnalysing } from './vocabulary.ts'

/**
 * Whether a conferência can be asked to look again, and why not when it cannot.
 *
 * The queue's selection bar asks for a reverify per selected row -- the same
 * request the verification screen's "Atualizar comparação" makes -- so the rule for
 * *which* rows may be asked has to be the same rule on both screens, or a
 * person selects a row the route will refuse and the batch spends a request
 * learning what the screen already knew.
 *
 * The route (`POST /api/verifications/:id/reverify`) refuses two things:
 *
 *   - `released` -- the preparation was made and handed over, so there is
 *     nothing left to check against.
 *   - a status still being analysed whose workflow answers -- a reverify is
 *     minutes of model calls, and asking twice buys a second identical answer
 *     at full price.
 *
 * Everything else is allowed through, including `failed` and `cancelled`,
 * where a fresh run is the only way back.
 *
 * A row whose analysis *died* mid-run still reads as analysing here and so is
 * not selectable, which is deliberate: the screen cannot tell a dead run from
 * a slow one, and the way out of a wedged workflow is `abandon`, not a signal
 * nothing is listening for.
 */
export function canReverify(status: string): boolean {
  return status !== 'released' && !isAnalysing(status)
}

/** What to tell somebody whose pointer is on a checkbox that will not tick. */
export function reverifyRefusal(status: string): string | undefined {
  if (status === 'released') return 'A requisição já foi para produção.'
  if (isAnalysing(status)) return 'A conferência já está sendo processada. Aguarde o resultado.'
  return undefined
}
